import debounce from './debounce';

$(() => {
	$(document).on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7unaccepted', '.wpcf7', debounce(() => {
		$('.wpcf7-response-output').append($('<span>').html('×').addClass('close-response'));
	}, 0));

	$(document).off('click.closeResponse', '.close-response').on('click.closeResponse', '.close-response', (event) => {
		event.preventDefault();
		$(event.currentTarget).closest('.wpcf7-response-output').slideUp();
	});

	$(document).off('focus.Reset', '.wpcf7-form-control.wpcf7-not-valid').on('focus.Reset', '.wpcf7-form-control.wpcf7-not-valid', (event) => {
		event.preventDefault();
		$(event.currentTarget).removeClass('wpcf7-not-valid').siblings('.wpcf7-not-valid-tip').slideUp();
	});
});



// WEBPACK FOOTER //
// ./assets/scripts/cf7.js